/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StickerMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABRUlEQVR4nN2VvUoDQRCAt1dB1Eqwzltole7mR2GdOVB8Axv/MMFH0UqbIOQdDLba+hIK2plCZe6ECJe92+wpogPT3Px8OzM7e879KyGSNWS5BtYXZH2fRcsYGSL6TjA5kD7OmhgrKk+WqwKwk7dPrqWSDiqAlLZguIrnKRV8V3IttBYArKfd7s4ckPQihjvVtxbgvZ8vviEuNAFCvvUVkPQsEFn6jRUEfH93Bji5Df0sy1eA5b7ae7krbCRnyYCM5NBsJUQvbIlsGYHknHl3+XN/jpIBQDLOKGcXEGDZMp8WLVLTNyC9RNxeJ9pbNM043wDWK7OFYn50yMD6kAwA0lcgPUbUVTeLxAPkxKVI9GOH5cmB9bbRl2T0pQIZxgC890uFP8koYhY3EwD6jt3ziBkcuFa/TNKBvec1Mxjjpu4nQ/6cfAAKOpJmx6n2QAAAAABJRU5ErkJggg==)
 */
export const StickerMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M18 2H6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h7.73c.12 0 .16-.26.05-.31A2.88 2.88 0 0 1 12 19a3 3 0 0 1 3-3h6.4c.2 0 .39-.11.45-.3a3 3 0 0 0 .15-.94V6a4 4 0 0 0-4-4ZM6.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM19 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-9.91 2.94a1 1 0 0 0-1.66 1.12 5.5 5.5 0 0 0 9.14 0 1 1 0 0 0-1.66-1.12 3.5 3.5 0 0 1-5.82 0Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M15 18a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2h-8Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
